module.exports = __webpack_public_path__ + "img/2.2c3dccef.webp";